import { render, staticRenderFns } from "./billingcommit.vue?vue&type=template&id=c97415b0"
import script from "./billingcommit.vue?vue&type=script&lang=js"
export * from "./billingcommit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports